import React, { useEffect, useState } from 'react'
import { Button, message, Modal, Radio, Select } from 'antd'
import './style.less'
import {} from '@ant-design/icons'
import { httpGet, httpPost } from '../../services/http'
import { ITaxYear } from './types'
import { accessOptions } from '../../lib/enums'

const { Option } = Select

type advisorRes = {
    advisors: any[]
}

export default function AttachAdvisorModal({
    loadOverviewData,
    taxYear,
    visible,
    setVisible,
}: {
    loadOverviewData: (i?: string) => Promise<ITaxYear[]>
    taxYear: ITaxYear
    visible: boolean
    setVisible: (isV: boolean) => void
}) {
    const [loading, setLoading] = useState<boolean>(true)
    const [loadingSubmit, setLoadingSubmit] = useState<boolean>(false)
    const [accessValue, setAccessValue] = useState<string>('view edit share')
    const [advisors, setAdvisors] = useState<any[]>([])
    const [selectedAdvisor, setSelectedAdvisor] = useState<string>(null)

    useEffect(() => {
        httpGet<advisorRes>('/ll-user-to-advisor/').then((res) => {
            setAdvisors(res.data?.advisors ?? [])
            setLoading(false)
        })
    }, [])

    const handleCancel = () => {
        setVisible(false)
    }

    function handleAccessChange(newValue) {
        setAccessValue(newValue.target.value)
    }

    function handleChangeAdvisor(newValue) {
        setSelectedAdvisor(newValue)
    }

    async function submitRequest() {
        setLoadingSubmit(true)
        if (selectedAdvisor) {
            await httpPost(`/ll-user-to-advisor/${taxYear.id}/advisor-access/${selectedAdvisor}`, {
                scopes: accessValue,
            })
            await loadOverviewData()
            setVisible(false)
        } else {
            message.warning('Please select an advisor first.')
        }
        setLoadingSubmit(false)
    }

    return (
        <>
            <Modal
                visible={visible}
                title={'Select Advisor'}
                footer={[<Button onClick={handleCancel}>Cancel</Button>]}
                onCancel={handleCancel}
                width={700}
            >
                <p>Add an advisor to help you with your compliance reports for this Tax Year.</p>
                <Select
                    showSearch
                    style={{ width: 600 }}
                    placeholder="Select Advisor"
                    optionFilterProp="children"
                    loading={loading}
                    disabled={loadingSubmit}
                    onChange={handleChangeAdvisor}
                    // onFocus={onFocus}
                    // onBlur={onBlur}
                    // onSearch={onSearch}
                    filterOption={(input, option) => {
                        for (var c in option.children) {
                            console.log(c, option.children[c])
                            if (option.children[c].toLowerCase()?.indexOf(input.toLowerCase()) >= 0) {
                                return true
                            }
                        }
                    }}
                >
                    {advisors.map((ad) => {
                        return (
                            <Option key={ad.id} value={ad.id}>
                                {ad.name} - {ad.company_name}
                            </Option>
                        )
                    })}
                </Select>
                <br />
                <br />
                If you can't find your advisor on the list, please let us know and we will sign him/her up.
                <br />
                <br />
                <Radio.Group
                    options={accessOptions}
                    onChange={handleAccessChange}
                    value={accessValue}
                    disabled={loadingSubmit}
                    optionType="button"
                    buttonStyle="solid"
                    size="small"
                />
                <br />
                <br />
                <Button loading={loadingSubmit} type="primary" onClick={submitRequest}>
                    Send request to advisor
                </Button>
            </Modal>
        </>
    )
}
